// 가견적 금액 한 곳 — 면적(소수 둘째 자리) × 평당단가 = 개산 금액 · 포함이면 그게 총액, 별도면 공급가(세액은 더한다) · 인메모리·Supabase 가 같이 쓴다.

import { amountsFromSupply, amountsFromTotal, type VatMode, type VatSplit } from "../money/vat";

const MONEY_MAX = 100_000_000_000;

export interface RoughAmounts extends VatSplit {
  area: number;
  gross: number;
}

export const roughAmounts = (areaPyeong: number, unitPrice: number, vatMode: VatMode): RoughAmounts => {
  const area = Math.round(areaPyeong * 100) / 100;
  const gross = Math.round(area * unitPrice);
  if (!Number.isFinite(gross) || gross < 0) {
    throw new Error("금액을 계산할 수 없습니다 — 면적과 단가를 확인해 주세요");
  }
  if (gross > MONEY_MAX) throw new Error("금액이 너무 큽니다 — 자릿수를 확인해 주세요");
  const split = vatMode === "EXCL" ? amountsFromSupply(gross) : amountsFromTotal(gross);
  // 별도면 세액을 더한 총액이 한도를 넘을 수 있다 — 저장 열(total)도 같은 한도로 막는다.
  if (split.total_amount > MONEY_MAX) throw new Error("금액이 너무 큽니다 — 자릿수를 확인해 주세요");
  return { area, gross, ...split };
};
